import type { RocketReaderChallenge } from '@/data/rocketReaderChallenges';

type ReadingCardProps = {
  challenge: RocketReaderChallenge;
  onReadAloud: () => void;
  speechSupported: boolean;
};

export function ReadingCard({
  challenge,
  onReadAloud,
  speechSupported,
}: ReadingCardProps) {
  return (
    <section className="rr-card rr-reading-card" aria-labelledby="rr-reading-title">
      <div className="rr-card-topline">
        <span id="rr-reading-title">Reading mission</span>
        <span>Level {challenge.level}</span>
      </div>
      <p className="rr-reading-text">{challenge.readingText}</p>
      <div className="rr-question-row">
        <h2>{challenge.question}</h2>
        <button
          type="button"
          className="rr-small-button"
          onClick={onReadAloud}
          disabled={!speechSupported}
          aria-label="Read the mission text aloud"
        >
          Read aloud
        </button>
      </div>
    </section>
  );
}
